export default {
    required: 'Campo requerido',
    minLength: 'Debe ingresar al menos {length} caracteres.',
    maxLength: 'Solo puede ingresar {length} caracteres.',
    email_invalid: 'Email es invalido',
    minValue: 'Este campo es invalido',
    onlyAlpha: 'Este campo solo permite valores de [A-Z]',
};
